import React, { Component } from "react";

import { ICategorySlideComponentProps } from "../types/props";
import { EchallengeImages, EDirection } from "../enums";
import { INDEX_CONFIG, SEGMENT_CONFIG, BUFFER_CONFIG, CATEGORY_CONFIG } from "../config";
import closeImage from "../../assets/close.svg";
import ReactTooltip from "react-tooltip";
import "./categorySlide.component.scss";
import TitleSlideComponent from "../titleSlideComponent/titleSlide.component";
class CategorySlideComponent extends Component<ICategorySlideComponentProps> {
  render() {
    return (
      <div className="category-slide">
        <ReactTooltip backgroundColor="rgb(0, 51, 89)" />
        <div className="category-slide--left">
          <div className="category-slide--buttons">
            <button
              className="category-slide--up"
              disabled={this.props.index === 0}
              onClick={this.up}
            >
              <span className="sr-only">Move Up</span>
            </button>
            <button
              className="category-slide--down"
              disabled={this.props.last}
              onClick={this.down}
            >
              <span className="sr-only">Move Down</span>
            </button>
            {/* <span className="category-slide--index">{this.props.index + 1}</span> */}
          </div>
        </div>
        <div className="category-slide--right">
          <div className="category-slide--header">
            <h3>{this.getCategory()}</h3>
          </div>
          {this.titleList()}
        </div>
      </div>
    );
  }

  titleList = (): JSX.Element[] => {
    return this.props.sections.map((section, index) => {
      return (
        <div className="title-view-link" key={index}>
          <TitleSlideComponent
            key={index}
            section={section}
            challenge={section.name}
            category={this.props.category}
            name={section.name}
            meta={section.meta}
            index={index}
            last={index === this.props.sections.length - 1}
            removeSlide={this.props.removeSlide}
          />
        </div>
      );
    });
  };

  up = () => {
    this.props.moveSlide(this.props.index, EDirection.up);
  };

  down = () => {
    this.props.moveSlide(this.props.index, EDirection.down);
  };

  getCategory = () => {
    const category = CATEGORY_CONFIG[this.props.category];
    if (category === undefined) {
      return `Not Configured`;
    } else return category;
  }
}

export default CategorySlideComponent;
